import React from 'react';
import { useSelector } from 'react-redux';
import ProjectCostPriorityRow from './projectCostPriorityRow/index';

const ProjectCostPriorityList = () => {
    const projectCostPriorityList = useSelector(state => state.projectCostPrioritys.projectCostPriorityList);
    return (
        <div className="app-main-content">
            {projectCostPriorityList.map((entry, index) => <ProjectCostPriorityRow key={index} projectCostPriority={entry} /> )}
        </div>
    );
};

export default ProjectCostPriorityList;


// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/projectCostPriorityList/index.js